const getHeaderTheme = () => ({
  height: '60px',
});

export default getHeaderTheme;
